import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { JSX, useState } from "react";
import { Action, VoidAction } from "../../util/func";

function NotifyDialog({ opened, title, text, onClose }: { opened: boolean; title: string; text: string; onClose: VoidAction }) {
  return (
    <Dialog open={opened} fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography whiteSpace="pre-wrap">{text}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>OK</Button>
      </DialogActions>
    </Dialog>
  );
}

export type useNotifyDialogArgs = { title: string; text: string; onClose?: VoidAction; };

export function useNotifyDialogDialog(): [JSX.Element, Action<useNotifyDialogArgs>] {
  const [open, setOpen] = useState(false);
  const [args, setArgs] = useState<useNotifyDialogArgs>();

  const dialog = (
    <NotifyDialog
      opened={open}
      title={args?.title ?? ""}
      text={args?.text ?? ""}
      onClose={() => {
        setOpen(false);
        args?.onClose?.();
      }}
    />
  );
  const show = (args: useNotifyDialogArgs) => {
    setOpen(true);
    setArgs(args);
  };

  return [dialog, show];
}
